<template>
    <div class="t-lk-online-courses-id">
        <div class="t-lk-container">
            <lk-breadcrumbs-cmp :breadcrumbs="breadcrumbs"></lk-breadcrumbs-cmp>
            <banner-native-cmp
                v-if="banner"
                v-animation:bottom.delay
                :banner="banner"
            >
            </banner-native-cmp>
            <lk-course-head-cmp
                :course="course"
                @toggleFavorites="toggleFavorites"
            ></lk-course-head-cmp>
            <div class="t-lk-online-courses-id__grid">
                <lk-course-content-cmp :course="course"></lk-course-content-cmp>
                <lk-course-info-cmp :course="course"></lk-course-info-cmp>
                <lk-course-rate-cmp :course="course"></lk-course-rate-cmp>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import lkBreadcrumbs from "@components/lk/lk-breadcrumbs/lk-breadcrumbs";
    import bannerNative from "@components/lk/banner-native/banner-native";
    import lkCourseHead from "@components/lk/lk-course/lk-course-head/lk-course-head";
    import { router } from "@src/routes";
    import LkCourseInfo from "@components/lk/lk-course/lk-course-info/lk-course-info";
    import LkCourseContent from "@components/lk/lk-course/lk-course-content/lk-course-content";
    import LkCourseRate from "@components/lk/lk-course/lk-course-rate/lk-course-rate";

    export default {
        name: "materials-vendors-id",
        data() {
            return {
                breadcrumbs: null,
                banner: null,
                course: null,
            }
        },
        components: {
            'lk-course-info-cmp': LkCourseInfo,
            'lk-course-content-cmp': LkCourseContent,
            'lk-course-rate-cmp': LkCourseRate,
            'lk-breadcrumbs-cmp': lkBreadcrumbs,
            'banner-native-cmp': bannerNative,
            'lk-course-head-cmp': lkCourseHead,
        },
        methods: {
            setData(data) {
                this.breadcrumbs = data.breadcrumbs;
                this.banner = data.banner;
                this.course = data.course;
            },
            toggleFavorites(val) {
                if (this.course)
                    this.course.isFavorite = val;
            }
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/materialsOnlineCoursesId.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url).then(
                (data) => {
                    next(vm => vm.setData(data.data));
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
    }
</script>


// WEBPACK FOOTER //
// src/templates/pages/lk/materials/materials-online-courses/id/index.vue